import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=79f883ce"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Opportunity.vue?vue&type=style&index=0&id=79f883ce&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f883ce')) {
      api.createRecord('79f883ce', component.options)
    } else {
      api.reload('79f883ce', component.options)
    }
    module.hot.accept("./Opportunity.vue?vue&type=template&id=79f883ce", function () {
      api.rerender('79f883ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Headers/Opportunity.vue"
export default component.exports